var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.7886C2 11.971 2.32476 11.187 2.90284 10.6089C3.48092 10.0308 4.26497 9.70605 5.0825 9.70605H11.2475C12.065 9.70605 12.8491 10.0308 13.4272 10.6089C14.0052 11.187 14.33 11.971 14.33 12.7886C14.33 13.1973 14.1676 13.5893 13.8786 13.8784C13.5895 14.1674 13.1975 14.3298 12.7887 14.3298H3.54125C3.13249 14.3298 2.74046 14.1674 2.45142 13.8784C2.16238 13.5893 2 13.1973 2 12.7886Z",
    stroke: "#424242",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16734 6.62375C9.44416 6.62375 10.4792 5.58869 10.4792 4.31188C10.4792 3.03506 9.44416 2 8.16734 2C6.89053 2 5.85547 3.03506 5.85547 4.31188C5.85547 5.58869 6.89053 6.62375 8.16734 6.62375Z",
    stroke: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileIcon);
export default __webpack_public_path__ + "static/media/userProfileIcon.ac2902414512fdf30983091f51e7b049.svg";
export { ForwardRef as ReactComponent };